module.exports = __webpack_public_path__ + "img/7.53709b54.png";